import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import withType from 'components/common/hoc/withType'
import { setPromotionData } from './actions'
import { GENERIC_SEARCH_PROMOTION_TYPE } from './constants'

const GenericPromotionBlock = () => null

export default compose(
  withType({ type: GENERIC_SEARCH_PROMOTION_TYPE }),
  connect(null, { setPromotionData }),
  lifecycle({
    componentDidMount() {
      this.props.setPromotionData(this.props)
    }
  })
)(GenericPromotionBlock)
